import { useT } from '../i18n.tsx';

/**
 * Eine sich drehende Schallplatte, solange ein Song laeuft.
 *
 * Das Designsystem heisst „Warm Vinyl" und ist auf einen Plattenladen
 * bei Abendlicht gebaut — eine Platte kam darin bisher nirgends vor.
 *
 * Der eigentliche Anlass ist aber ein Loch im Ablauf: Waehrend der Song
 * laeuft, vergeht die meiste Zeit einer Runde, und der Bildschirm ist
 * genau dann am leersten. Das Cover darf nicht gezeigt werden, es waere
 * die Antwort. Also braucht es etwas, das Bewegung zeigt, ohne etwas zu
 * verraten.
 *
 * Bewusst KEIN Fortschrittsbalken: wie weit der Song schon gelaufen
 * ist, hilft beim Raten nicht und macht nur Druck. Eine Platte dreht
 * sich einfach — sie sagt „es laeuft", mehr nicht.
 */
export function Turntable({
  /** Dreht sich. Steht die Platte, ist gerade kein Ton. */
  spinning = true,
  /** Groessere Darstellung fuer die Fernsehansicht. */
  large = false,
}: {
  spinning?: boolean;
  large?: boolean;
}) {
  const t = useT();

  return (
    <div
      className={[
        'turntable',
        large ? 'turntable--lg' : '',
        spinning ? 'turntable--spinning' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      /**
       * Als Bild ausgezeichnet, nicht als Dekoration: Fuer jemanden mit
       * Screenreader ist „es laeuft gerade ein Song" eine echte
       * Information — es ist der Grund, warum gerade nichts passiert.
       */
      role="img"
      aria-label={t('game.listening')}
    >
      <span className="turntable__disc" aria-hidden="true">
        <span className="turntable__label" />
      </span>
    </div>
  );
}
